<div class="flag-email-page">
  <div class="flag-email-card">
    <!-- Header -->
    <div class="flag-email-header">
      <div class="header-title">
        <div class="icon-badge">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="22"
            height="22"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
            ></path>
            <line x1="4" y1="22" x2="4" y2="15"></line>
          </svg>
        </div>
        <div class="title-text">
          <h3>Report Email</h3>
          <span class="subtitle"
            >Help us keep the portal accurate and safe</span
          >
        </div>
      </div>
    </div>

    <!-- Body Content -->
    <div class="flag-email-body">
      @if (isLoadingReasons) {
        <div class="state-container loading-state">
          <div class="spinner"></div>
          <p>Loading report options...</p>
        </div>
      } @else if (hasTokenError) {
        <div class="state-container error-state">
          <div class="state-icon-badge error">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="28"
              height="28"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <h4>Unable to Process Report</h4>
          <p>{{ tokenErrorMessage }}</p>
        </div>
      } @else if (isSubmitted) {
        <div class="state-container success-state">
          <div class="state-icon-badge success">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="32"
              height="32"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          <h4>Thank You!</h4>
          <p>
            Your report has been submitted successfully. Our team will review
            this email promptly to ensure platform integrity and safety.
          </p>
        </div>
      } @else {
        <form (ngSubmit)="onSubmit()" #reportForm="ngForm">
          <div class="section-heading">Select a reason for flagging</div>

          <!-- Dynamic Reasons List -->
          <div class="reasons-list">
            @for (reason of reportReasons; track reason.id) {
              <label
                class="reason-option"
                [class.selected]="selectedReason?.code === reason.code"
              >
                <input
                  type="radio"
                  name="reportReason"
                  [value]="reason"
                  [checked]="selectedReason?.code === reason.code"
                  (change)="selectReason(reason)"
                />
                <span class="radio-custom"></span>
                <span class="reason-label">{{ reason.label }}</span>
              </label>
            }
          </div>

          <!-- Severity Selection -->
          <div class="severity-section">
            <label for="reportSeverity" class="severity-label">Severity</label>
            <select
              id="reportSeverity"
              class="severity-select"
              name="reportSeverity"
              [(ngModel)]="selectedSeverity"
            >
              @for (option of severityOptions; track option.value) {
                <option [ngValue]="option.value">{{ option.label }}</option>
              }
            </select>
          </div>

          <!-- Optional Text Area -->
          <div class="details-section">
            <label for="reportDetails" class="details-label">
              Additional Details <span class="optional-tag">(Optional)</span>
            </label>
            <textarea
              id="reportDetails"
              class="details-textarea"
              name="reportDetails"
              rows="4"
              [(ngModel)]="details"
              placeholder="Provide any additional context or explanation..."
              maxlength="500"
            ></textarea>
            <div class="char-count">{{ details ? details.length : 0 }}/500</div>
          </div>

          @if (submitErrorMessage) {
            <div class="submit-error-banner">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <span>{{ submitErrorMessage }}</span>
            </div>
          }

          <!-- Form Action Footer -->
          <div class="flag-email-footer">
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="!selectedReason || isSubmitting"
            >
              @if (isSubmitting) {
                <span class="spinner-small"></span>
                <span>Submitting Report...</span>
              } @else {
                <span>Submit Report</span>
              }
            </button>
          </div>
        </form>
      }
    </div>
  </div>
</div>
